<template>
    <div id="lhr20211125">
        <el-form ref="formRef" :rules='formRules' :model="form" label-width="90px">
                <el-row :gutter="24">
                      <el-col :span="6">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select :disabled="!isEdit||!isAdd" v-model="form.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                    <el-col :span="6">
                        <el-form-item label="设备类型" prop="typeId">
                            <avue-input-tree  :props='treeDeviceTypeProps' style="width:100%;height:32px" :disabled="!deviceTypeFlag||!isEdit" v-model="form.typeId" placeholder="请选择 设备类型" type="tree" :dic="deviceTypeList"></avue-input-tree>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="设备编号" prop="code" >
                              <el-input placeholder="请输入 设备编号" :disabled="!isEdit" v-model="form.code" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item label="设备名称" prop="name" >
                            <div style="display:flex">
                                    <el-input :disabled="!isEdit" placeholder="请输入 设备名称" v-model="form.name" maxlength="50" show-word-limit clearable ></el-input>

                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="设备型号" prop="model" >
                              <el-input :disabled="!isEdit" placeholder="请输入 设备型号"  v-model="form.model" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="设备品牌" prop="brand" >
                              <el-input :disabled="!isEdit" placeholder="请输入 设备品牌"  v-model="form.brand" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="生产厂家" prop="productionFactory" >
                              <el-input :disabled="!isEdit" placeholder="请输入 生产厂家" v-model="form.productionFactory" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="供货商" prop="provider" >
                              <el-input :disabled="!isEdit" placeholder="请输入 供货商" v-model="form.provider" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                    </el-col>

                    <el-col :span="6">
                          <el-form-item label="采购价格" prop="purchasePrice">
                                  <!-- <el-input  class="input-money" :disabled="!isEdit" clearable  placeholder="请输入采购价格"  v-model="form.purchasePrice"  maxlength="12"
                                  />  -->
                                  <moneyInput v-model="form.purchasePrice" placeholder="请输入 采购价格" :disabled="!isEdit" template="append" style="width: 100%"  />
                          </el-form-item>
                    </el-col>


                    <el-col :span="6" style="height:54px" >
                          <el-form-item label="启用日期" prop="startUseTime" style="width:100%" >
                             <el-date-picker
                             :disabled="!isEdit"
                             style="width:100%"
                            v-model="form.startUseTime"
                            type="date"
                            placeholder="请选择 启用日期"
                            align="right"
                            value-format="yyyy-MM-dd 00:00:00"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6" style="height:54px" >
                          <el-form-item label="保修期" prop="guaranteeEndTime" style="width:100%" >
                             <el-date-picker
                             :disabled="!isEdit"
                             style="width:100%"
                            v-model="form.guaranteeEndTime"
                            type="date"
                            placeholder="请选择 保修期"
                            align="right"
                            value-format="yyyy-MM-dd 00:00:00"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6" >
                          <el-form-item label="使用年限" prop="durableYears" style="width:100%" >
                             <el-input-number placeholder="请输入 使用年限" :disabled="!isEdit" v-model="form.durableYears" @change="handleChange" :min="0" :max="99" ></el-input-number>
                          </el-form-item>

                      </el-col>

                      <el-col :span="6" style="height:54px">
                          <el-form-item label="资产属性" prop="assetType" style="width:100%" >
                             <el-select :disabled="!(isEdit||isAdd)" v-model="form.assetType" placeholder="请选择 资产属性" style="width:100%">
                                  <el-option
                                      v-for="item in assetTypeList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                          </el-form-item>

                      </el-col>

                       <el-col :span="6" style="height:54px">
                          <el-form-item label="资产状态" prop="assetStatus" style="width:100%" >
                             <el-select :disabled="!(isEdit||isAdd)" v-model="form.assetStatus" placeholder="请选择 资产状态" style="width:100%" @change='assetStatusChange'>
                                  <el-option
                                      v-for="item in assetStatusList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                          </el-form-item>

                      </el-col>

                       <el-col :span="6" style="height:54px" >
                          <el-form-item label="报废日期" prop="scrapTime" style="width:100%"  >
                             <el-date-picker
                             :disabled="!isEdit||form.assetStatus!=2"
                             style="width:100%"
                            v-model="form.scrapTime"
                            type="date"
                            placeholder=" 请选择 报废日期"
                            align="right"
                            value-format="yyyy-MM-dd 00:00:00"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6" style="height:54px">
                          <el-form-item label="使用状态" prop="useStatus" style="width:100%" >
                             <el-select disabled  v-model="form.useStatus" placeholder="请选择 使用状态" style="width:100%">
                                  <el-option
                                      v-for="item in useStatusList"
                                      :key="item.dictKey"
                                      :label="item.dictValue"
                                      :value="item.dictKey">
                                  </el-option>
                              </el-select>
                          </el-form-item>

                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="所属部门" prop="deptId" >
                              <avue-input-tree :disabled="!deptNameFlag||!isEdit" style="width:100%" :props='treeDeptProps' v-model="form.deptId" placeholder="请选择 所属部门" type="tree" :dic="deptList"></avue-input-tree>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="责任人" prop="chargeManId" >
                               <choice-people :limit="1" :allUserList='realInspectManList' :remainUserListInside.sync="realInspectManList" :projectId="form.projectId" :disabled="!isEdit" message="请选责任人" placeholder="请选择 责任人"></choice-people>
                          </el-form-item>
                      </el-col>
                      <el-col :span="6">
                          <el-form-item label="存放位置" prop="areaId" >
                              <!-- <avue-input-tree  :parent="false" ref="aabb" :disabled="!areaFlag||!isEdit" style="width:100%" :props='treeAreaProps' v-model="form.areaId" placeholder="请选择 存放位置" type="tree" :dic="areaList"></avue-input-tree> -->
                                <el-select
                                  style="width: 100%;"
                                    clearable
                                    @clear="areaClear"
                                    :disabled="!areaFlag||!isEdit"
                                    :value="form.areaName"  
                                    placeholder="请选择 存放位置"
                                    :popper-append-to-body='false'
                                  >
                                  <el-input class="searchInput" v-model="areaNameInput" placeholder="输入关键字进行过滤"></el-input>
                                    <el-option
                                      :value="form.areaName"
                                      show-all-levels
                                      :label="form.areaName"
                                    >
                                      <el-tree
                                        node-key="id"
                                        :data="areaList"
                                        :props="treeAreaProps"
                                       ref="tree"
                                        :filter-node-method="filterNode"
                                        @node-click="areaNodeTreeClick"
                                      >
                                      </el-tree>
                                    </el-option>
                                  </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="6">
                          <el-form-item label="第三方编码"  prop="thirdPlatformCode" >
                               <el-input placeholder="请输入 第三方编码" :disabled="!isEdit" v-model="form.thirdPlatformCode" maxlength="50" show-word-limit clearable></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24" v-if="showContract">
                          <el-form-item label="关联合同">

                               <avue-crud
                                :option="option"
                                :table-loading="loading"
                                :data="contractList"
                                :page.sync="page"
                                v-model="selectForm"
                                ref="crud"
                                @selection-change="handleSelectionChange"
                                @current-change="currentChange"
                                @size-change="sizeChange"
                                @on-load="getContractByDeviceId(row.id)"
                                @refresh-change="getContractByDeviceId(row.id)">
                                <template slot="menuLeft">
                                    <el-button type="primary" size="small" @click="choiceConstract" >关联合同</el-button>
                                 <el-button type="primary" size="small" @click="removeChecked" >移除</el-button>
                                </template>
                                <template slot-scope="scope" slot="menu">
                                     <el-button type="primary" size="small" @click="removeContract(scope.row.id)" >移除</el-button>
                                 </template>
                                <!-- <template slot="choice" slot-scope="scope">
                                    <el-radio v-model="radio" :label="scope.row" @change='radioChange()'> {{' '}}</el-radio>
                                </template> -->
                                <template slot="lifecycleIndex" slot-scope="scope">
                                <el-tag>
                                {{
                                    tool.getDictionaryValue(
                                    lifeCycleList,
                                    'dictValue',
                                    'dictKey',
                                    scope.row.lifecycleIndex
                                    )
                                }}
                                </el-tag>
                            </template>

                                <template slot="settledAmount" slot-scope="scope">
                                    <div class="money"><span>{{tool.money_format_allowvoid(scope.row.settledAmount)   }}</span></div>
                                </template>
                                <template slot="unsettledAmount" slot-scope="scope">
                                    <div class="money"><span>{{tool.money_format_allowvoid(scope.row.unsettledAmount)   }}</span></div>
                                </template>
                                <template slot="contractAmount" slot-scope="scope">
                                    <div class="money"><span>{{tool.money_format_allowvoid(scope.row.contractAmount)  }}</span></div>
                                </template>
                            </avue-crud>
                          </el-form-item>
                      </el-col>

                      <el-col :span="24" v-if="showContract">
                          <el-form-item label="巡检标准" prop="contractName" >
                              <el-col :span="12">
                                  <div style="display:flex">
                                        <el-input v-model="form.inspectName" readonly></el-input>
                                        <el-button type="primary" size="small" @click="choiceInspectStandard" >选择巡检标准</el-button>
                                  </div>
                              </el-col>
                          </el-form-item>
                      </el-col>
                       <el-col :span="24" v-if="showContract">
                          <el-form-item label="维保标准" prop="contractName" >
                              <el-col :span="12">
                                  <div style="display:flex">
                                        <el-input v-model="form.upkeepName" readonly></el-input>
                                        <el-button type="primary" size="small" @click="choiceMaintenanceStandard" >选择维保标准</el-button>
                                  </div>
                              </el-col>
                          </el-form-item>
                      </el-col>

                      <el-col :span="24">
                          <el-form-item label="备注说明" prop="description" >
                              <el-input :disabled="!isEdit" placeholder="请输入 备注说明" type="textarea" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>

                      <el-col :span="24">
                          <el-form-item label="设备图片" prop="imgAttach" >

                              <vUpload message="提示：只能上传jgp/png文件，且" messageType="pre" :types="['jpg','png']" :disabled="!isEdit" :fileList.sync="form.imgAttach"></vUpload>
                          </el-form-item>
                      </el-col>

                       <el-col :span="24">
                          <el-form-item label="设备档案" prop="imgAttach" >
                              <vUpload :disabled="!isEdit" :limit="10" :fileList.sync="form.fileAttach"></vUpload>
                          </el-form-item>
                      </el-col>

                      <el-col :span="24">
                        <div class="btnArea" style="text-align:right">
                            <el-button type="primary" @click="submitRecord" style="margin-right: 20px"
                            v-if="isEdit" >确定</el-button
                            >
                            <el-button @click="closeRecord">取消</el-button>
                        </div>
                      </el-col>
                </el-row>
          </el-form>
            <el-dialog
                title="选择合同"
                :visible.sync="choiceContractDialogFlag"
                v-if="choiceContractDialogFlag"
                width="70%"
                append-to-body="true"
                :before-close="handleClose">
             <!-- :projectId="form.projectId" -->
             <choiceContract @cancleOperate="contractCancleOperate" :projectId='this.form.projectId' @close='dialogClose'  @getConstract="getContract"></choiceContract>
             </el-dialog>
        <!-- 选择设备巡检标准 -->
            <el-dialog
            title="选择设备巡检标准"
            v-if="choiceInspectStandardDialogFlag"
            :visible.sync="choiceInspectStandardDialogFlag"
            append-to-body="true"

            :before-close="handleClose">

                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{"选择设备巡检标准"}}
                                </span>
                                <!-- <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i> -->

                        </div>
                        <el-divider></el-divider>
                </template>
                <!-- <div :style="'height:'+ dialogBodyHight + 'px;overflow:hidden;'"> -->
            <InspectStandard v-if="choiceInspectStandardDialogFlag" :inspectIdList='inspectIdList' :projectId="this.form.projectId" @choiceData="getInspectStandard" @cancelOperate="choiceInspectStandardClose"></InspectStandard>
            <!-- </div> -->
            </el-dialog>

            <el-dialog
            title="选择设备维保标准"
            v-if="choiceMaintenanceStandardDialogFlag"
            :visible.sync="choiceMaintenanceStandardDialogFlag"
            append-to-body="true"

            :before-close="handleClose">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{"选择设备维保标准"}}
                                </span>
                                <!-- <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i> -->

                        </div>
                        <el-divider></el-divider>
                </template>
            <MaintenanceStandard :projectId="this.form.projectId" @choiceData="getMaintenanceStandard" @cancelOperate="choiceMaintenanceStandardClose"></MaintenanceStandard>
            </el-dialog>
    </div>
</template>

<script>
import vUpload from '@/views/components/v-upload';
import {
  treeByProjectDeptId,
  treeByProjectDeviceTypeId,
  treeByProjectAreaId,
} from '@/api/crmedical/device/device';
import { getProjectList } from '@/api/crmedical/project/project';
import InspectStandard from '@/components/device/choiceStandard/choiceInspectionStandardNew';
import MaintenanceStandard from '@/components/device/choiceStandard/choiceMaintenanceStandard';
import choiceContract from '@/components/choiceContract/choiceDeviceContract';
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import {
  getContractByDeviceId,
  getDetailByDeviceId,
  addContract,
  removeContract,
  addInspectAndUpkeep,
  addInspect,
  addUpkeep

} from '@/api/crmedical/device/addDevice';
import { getDictData } from '@/api/crmedical/contract/contract/contract';
import { type } from 'os';
import moneyInput from '@/components/money-input'
import orderListOption from '../../../views/crmedical/order/order-list/order-list-option';
export default {
  components: {
    vUpload,
    InspectStandard,
    MaintenanceStandard,
    choiceContract,
    choicePeople,
    moneyInput
  },
  props: {
    formData: {
      default: {},
    },
    isEdit: {
      default: true,
    },
    showContract: {
      default: false,
      type: Boolean,
    },
    row: {
      default: {},
    },
    isAdd: {
      default: true, //默认未新增操作
    },
  },
  watch: {
    realInspectManList: {
      handler() {
        if (this.realInspectManList.length > 0) {
          console.log(this.realInspectManList[0]);
          this.$set(this.form, 'chargeManId', this.realInspectManList[0].id);

          this.form.chargeManName = this.realInspectManList[0].realName;
          this.$forceUpdate()
        }
      },
      immediate: true,
      deep: true,
    },
    'areaNameInput'(val){
        this.$refs.tree.filter(val);
    }
  //  'form.assetStatus' :{
  //     handler() {
  //       if (this.assetStatus == 2) {
  //         console.log(this.realInspectManList[0]);
  //         this.form.scrapTime = ''
  //       }
  //     },
  //     immediate: true,
  //     deep: true,
  //  }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if(value){
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入小数点前9位后2位小数的金额'));
        }
      }else{
         callback();
      }
    };
    // var scrapTimeValidate = (assetStaus)=>{
    //   return  (rule, value, callback) => {
    //    if(assetStaus == 2 &&)
    //     if(value){
    //       if (reg.test(value)) {
    //         callback();
    //       } else {
    //         callback(new Error('请输入小数点前9位后2位小数的金额'));
    //       }
    //     }else{
    //       callback();
    //     }
    //   }
    // }
    return {
      defaultForm: {
        projectId: '',
        deviceType: '',
        code: '',
        deviceName: '',
        areaName:'',
        startUseTime: '',
        guaranteeEndTime: '',
        scrapTime: '',
        deptId: '',
        chargeManId: '',
        areaId: '',
        useStatus:'',
        assetType:'',
        assetStatus:''
      },
      form: {},
      inspectIdList:[],//巡检设备id集合
      oldAreaId:'',
      checkedContractList:[],
      assetTypeList:[],//资产属性
      assetStatusList:[],//资产状态
      useStatusList:[],//使用状态
      areaList: [],
      areaFlag: false,
      deviceTypeList: [],
      deviceTypeFlag: false,
      deptNameFlag: false,
      choiceContractDialogFlag: false,
      contractList: [], //合同列
      choiceMaintenanceStandardDialogFlag: false,
      choiceInspectStandardDialogFlag: false,
      deptList: [],
      projectList: [],
      realInspectManList: [], //责任人
      treeDeptProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      treeDeviceTypeProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      treeAreaProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      option: {
        index: true,
        selection: true,
        dialogFull:false,
        indexLabel: '序号',
        page: true,
        height: '300',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '合同编号',
            prop: 'code',
          },
          {
            label: '合同名称',
            prop: 'name',
          },
          {
            label: '合同类型',
            prop: 'type',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl:
              '/api/v4ward/projectDict/dictionary?code=project_contract_type&&projectId=' +
              this.row.projectId,
          },
          {
            label: '合同对象',
            prop: 'partnerName',
          },
          {
            label: '签订日期',
            prop: 'signTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '合同金额',
            prop: 'contractAmount',
            slot: true,
            align:'right'
          },
          {
            label: '合同状态',
            prop: 'lifecycleIndex',
            slot: true,
          },
          {
            label: '已结算金额',
            prop: 'settledAmount',
            slot: true,
            align:'right'
          },
          {
            label: '未结算金额',
            prop: 'unsettledAmount',
            slot: true,
            align:'right'
          },
          // {
          //   label: '备注',
          //   prop: 'remark',
          // },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      lifeCycleList: [],
      formRules: {
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        typeId: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        code: [{ required: true, message: '请输入设备编号', trigger: 'change' }],
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        startUseTime: [{ required: false, message: '请选择启用时间', trigger: 'blur' }],
        guaranteeEndTime: [{ required: false, message: '请选择保修期', trigger: 'blur' }],
        durableYears:[{ required: false, message: '请输入使用年限', trigger: 'change' }],
        assetType:[{ required: true, message: '请选择资产属性', trigger: 'change' }],
        assetStatus:[{ required: true, message: '请选择资产状态', trigger: 'change' }],
        scrapTime: [{ required: false, message: '', trigger: 'change' }],
        deptId: [{ required: true, message: '请选择所属部门', trigger: 'change' }],
        // chargeManId: [{ required: true, message: '请选择责任人', trigger: 'change' }],
        areaId: [{ required: true, message: '请选择存放位置', trigger: 'change' }],
        purchasePrice:[{ required: false, validator: validatePass, trigger: 'blur' }],
      },
      areaNameInput:'',
    };
  },
  mounted(){
    window.onresize = ()=>{
      this.$refs.crud.$refs.table.doLayout()

    }
                //  this.dialogFull = false;
                // let bodyHight = document.body.clientHeight;

                // this.dialogBodyHight = bodyHight - 320;
  },

 async created() {
  this.form = Object.assign({}, this.defaultForm, this.formData);
    console.log('form', this.form, this.isAdd);
   await this.initData()
    if (this.isAdd) {

      this.$set(this.form,'assetStatus','0')

       this.$set(this.form,'assetType','0')
      console.log('新增中');
      this.getProjectList();
      this.getDeptList(this.form.projectId);
      this.getDeviceTypeList(this.form.projectId);
      this.getAreaList(this.form.projectId);
       this.$set(this.form,'useStatus','0')
    } else {
      this.loadProjectLifeCycle();
      if (this.row) {
        console.log('row', this.row);
        console.log('id', this.row.id);
        this.getProjectList();
        this.getDetailByDeviceId(this.row.id);
        this.getContractByDeviceId(this.row.id);
        this.getDeptList(this.row.projectId);
        this.getDeviceTypeList(this.row.projectId);
        this.getAreaList(this.row.projectId);
      }
    }
  },
  methods: {
    areaClear(){
      console.log("clear")
      this.$set(this.form, 'areaId', '');
      this.$set(this.form, 'areaName', '');
      this.$forceUpdate()
    },
    areaNodeTreeClick(node){
      console.log(node)
      if(node.nodeType==1 ){
        return
      }else{
        this.form.areaName = node.title
      
        this.form.areaId = node.id
        this.$refs.formRef
        this.$forceUpdate()
      }
    },
     filterNode(value, data) {
       console.log(data)
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      },
                dialogFullChange(){
                  console.log('dialogFullChange=======================>');
                        let bodyHight = document.body.clientHeight;
                        this.dialogFull = !this.dialogFull;
                        if(this.dialogFull){
                                this.dialogBodyHight = bodyHight - 180;
                                console.log(this.dialogBodyHight);
                                // this.$refs.choiceContract.dialogFullChange(true);
                        }else{
                                this.dialogBodyHight = bodyHight - 320;
                                console.log(this.dialogBodyHight);
                                // this.$refs.choiceContract.dialogFullChange(false);
                        }
                },
    areaClick(node){
      console.log('++++',node)
      // this.$set(node,'disabled',true)
      // console.log(this.areaList)
      if(node.hasChildren){
        console.log("dddd")

        this.$nextTick(()=>{
          this.$set(this.form,'areaId',this.oldAreaId)
        })
        // this.form.areaId =this.oldAreaId
      }else{
        console.log("bbb")
        this.oldAreaId = node.id
      }
      console.log("areaid",this.form.areaId)
    },
    assetStatusChange(val){//资产状态发生变化报废时间清空禁用
      console.log('资产状态的资，'+val)
      if(val != 2){
        this.$set(this.form,'scrapTime','')
        // this.form.scrapTime = ''
        this.formRules .scrapTime = [{ required: false, message: '', trigger: 'change' }]
      }else{
        this.formRules .scrapTime = [{  required: true, message: '请选择报废日期', trigger: 'blur' }]
      }
    },
    initData(){
      getDictData({ code: 'device_asset_type' }).then((res) => {
        this.assetTypeList = res.data;
      });
      getDictData({ code: 'device_asset_status' }).then((res) => {
        this.assetStatusList = res.data;
      });
      getDictData({ code: 'device_use_status' }).then((res) => {
        this.useStatusList = res.data;
      });
    },
    closeRecord(){
      //关闭
      this.$emit("cancle")
    },
    handleSelectionChange(val){
      this.checkedContractList = val
    },
    removeChecked() {
      let idArry = []
      this.checkedContractList.forEach(item=>{
        idArry.push(item.id)
      })
      let ids = idArry.join(",")
      this.$confirm('此操作将删除已勾选合同, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeContract(ids).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getContractByDeviceId(this.row.id);
        });
      });
    },
    removeContract(id) {
      this.$confirm('此操作将删除改合同, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removeContract(id).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getContractByDeviceId(this.row.id);
        });
      });
    },
    //加载合同状态(生命周期)
    loadProjectLifeCycle() {
      getDictData({ code: 'contract_lifecycle' }).then((res) => {
        this.lifeCycleList = res.data;
      });
    },
    currentChange(val) {
      this.page.currentPage = val;
    },
    sizeChange(val) {
      this.page.pageSize = val;
    },
    //获取设备信息
   async getDetailByDeviceId(deviceId) {
    await   getDetailByDeviceId({ id: deviceId }).then(({ data }) => {
        //巡检标准id处理
       if(data.standardId){
          this.inspectIdList = data.standardId.split(',')
       }else{
          this.inspectIdList =[]
       }
        console.log("巡检标准id",this.inspectIdList)
        this.form = data;
        this.form.assetType+=''
        this.form.assetStatus+=''
        this.form.useStatus+=''
        console.log("form----",this.form)
        // this.form.useStatus = this.form.useStatus + ''
        if(this.form.chargeManId){
          let obj = {
          id: this.form.chargeManId,
          realNameAndPhone: this.form.chargeManName,
          realName: this.form.chargeManName,
        };
        this.realInspectManList.push(obj);
        }

      });
    },
    getContractByDeviceId(deviceId) {
      if (typeof deviceId == 'string' && this.showContract) {
        this.loading = true;
        console.log('deviceId', deviceId);
        getContractByDeviceId({
          id: deviceId,
          current: this.page.currentPage,
          size: this.page.pageSize,
        })
          .then((res) => {
            this.contractList = res.data.records;
            this.page.total = res.data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    submitRecord() {
      //提交新增记录
      console.log(this.form);
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.$emit('addForm', Object.assign({}, this.form));
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    projectIdChange(val) {
      this.areaNameInput = ''
      this.$set(this.form, 'deptName', '');
      this.$set(this.form, 'deptId', '');
      this.$set(this.form, 'typeId', '');
      // this.$set(this.form, 'deptId', '');
      this.realInspectManList = [];
      this.$set(this.form, 'chargeManName', '');
      this.$set(this.form, 'chargeManId', '');
      this.$set(this.form, 'areaId', '');
      this.$set(this.form, 'areaName', '');
      this.$set(this.form, 'standardId', '');
      this.$set(this.form, 'upkeepId', '');
      this.$set(this.form, 'upkeepName', '');
      this.$set(this.form, 'inspectName', '');
      this.getDeptList(val);
      this.getDeviceTypeList(val);
      this.getAreaList(val);
    },
    getAreaList(value) {
      this.areaFlag = false;
      treeByProjectAreaId({ projectId: value }).then((res) => {
        this.areaList = res.data;
        this.areaFlag = true;
        this.$refs["aabb"].$children[0].popperAppendToBody = false
        this.$forceUpdate()
        console.log('----',this.$refs["aabb"])
        // console.log(document.querySelector(''))
      });
    },
    getDeviceTypeList(value) {
      this.deviceTypeFlag = false;
      treeByProjectDeviceTypeId({ projectId: value }).then((res) => {
        this.deviceTypeList = res.data;
        console.log('设备类型', this.deviceTypeList);
        this.deviceTypeFlag = true;
      });
    },
    getDeptList(value) {
      this.deptNameFlag = false;
      treeByProjectDeptId({ projectId: value }).then((res) => {
        this.deptList = res.data;
        this.deptNameFlag = true;
      });
    },
    getProjectList() {
      getProjectList().then(({ data }) => {
        console.log('projectList', data);
        this.projectList = data;
      });
    },
    choiceInspectStandard() {
      console.log(this.form);
      console.log("inspectIdList",this.inspectIdList)
      this.choiceInspectStandardDialogFlag = true;
    },
    getInspectStandard(val) {
      let standardNameList = []
      let standardIdList =[]
      val.forEach(item=>{
        standardNameList.push(item.name)
        standardIdList.push(item.id)
      })
      console.log(standardNameList,standardIdList)
      this.$set(this.form, 'inspectName', standardNameList.join(','));
      this.form.standardId = standardIdList.join(',');
      let obj = {
        id: this.row.id,
        standardId: this.form.standardId,
        projectId: this.row.projectId,
      };

      addInspect(obj).then(() => {
        this.$message.success('关联巡检标准成功');
        this.choiceMaintenanceStandardDialogFlag = false;
        this.getDetailByDeviceId(this.row.id);
      });
      console.log('巡检标准', val);
      this.choiceInspectStandardDialogFlag = false;
    },
    choiceInspectStandardClose() {

      this.choiceInspectStandardDialogFlag = false;
    },

    choiceMaintenanceStandard() {
      console.log(this.form);
      this.choiceMaintenanceStandardDialogFlag = true;
    },
    getMaintenanceStandard(val) {
      this.$set(this.form, 'upkeepName', val.name);
      this.form.upkeepId = val.id;
      let obj = {
        id: this.row.id,
        upkeepId: val.id,
        projectId: this.row.projectId,
      };
      console.log("维保标准参数",obj )
      addUpkeep(obj).then(() => {
        this.$message.success('关联维保标准成功');
        this.choiceMaintenanceStandardDialogFlag = false;
      });
    },
    choiceMaintenanceStandardClose() {
      this.choiceMaintenanceStandardDialogFlag = false;
    },
    handleClose() {
      this.choiceInspectStandardDialogFlag = false;
      this.choiceMaintenanceStandardDialogFlag = false;
      this.choiceContractDialogFlag = false;
    },
    choiceConstract() {
      this.choiceContractDialogFlag = true;
    },
    contractCancleOperate() {
      this.choiceContractDialogFlag = false;
    },
    getContract(val) {
      if (val.id && this.row.id) {
        let obj = {
          deviceId: this.row.id,
          contractId: val.id,
        };
        addContract(obj)
          .then(() => {
            this.$message.success('添加关联合同成功！');
            this.page.currentPage = 1;
            this.getContractByDeviceId(this.row.id);
            this.choiceContractDialogFlag = false;
          })
          .catch(() => {
            this.choiceContractDialogFlag = false;
          });
      } else {
        this.choiceContractDialogFlag = false;
      }
    },
  },
};
</script>
<style>
#lhr20211125 .avue--disabled {
  color:#606266;
}

/* #lhr20211125 > form > div > div:nth-child(19) > div > div > div > div.el-select-dropdown.el-popper > div.el-scrollbar > div.el-select-dropdown__wrap.el-scrollbar__wrap > ul > li > div > div:nth-child(1) > div > div > span{
   color:red;
} */
</style>

<style scoped>
/deep/ .el-input__inner{
  height: 32px;
  box-sizing: border-box;
}
/deep/ .el-col-6 {
  height: 54px;
  box-sizing: border-box;
}
::v-deep .input-money .el-input__inner {
  text-align: right;
}
::v-deep .input-money .el-input__inner:-ms-input-placeholder {
  text-align: left;
}

::v-deep .input-money .el-input__inner::-webkit-input-placeholder {
  text-align: left;
}

::v-deep .input-money .el-input__inner::-moz-input-placeholder {
  text-align: left;
}
::v-deep .el-input-number {
  line-height: 30px;
}
::v-deep .searchInput  .el-input__inner {
  border-color: #DCDFE6;
}
/* ::v-deep .el-dialog {
  width: 100%;
  height: 100vh;
  margin-top: 0!important;
} */
</style>
